export default "<p>adaptive-placement-test works!</p>\n"